import type { PropsWithChildren } from "react"
import React from "react"
import { Helmet } from "react-helmet"

import { CallToAction } from "../cta/CallToAction"
import { Header } from "./Header"
import { Footer } from "./Footer"
import { ProgressBar } from "./ProgressBar"

export type PageProps = PropsWithChildren<{
  header: JSX.Element | string
  title: string
  description: string
  keywords: string
  slug?: string
}>

export const Page = (props: PageProps) => {
  const {
    children,
    header,
    title,
    description: suppliedDescription,
    keywords,
    slug,
  } = props

  const docTitle = `${title} - XRPLAccelerator.org`
  const description =
    suppliedDescription ||
    `XRPL Accelerator supports entrepreneurs building on the XRP Ledger. Through a tailored 360-degree analysis of their business model, the program helps develop a strategic blueprint for maximized growth potential.`
  const image = `https://xrplaccelerator.org/images/metadata.png`

  const metadata = [
    {
      charSet: `utf-8`,
    },
    {
      property: `og:title`,
      content: docTitle,
    },
    {
      property: `og:description`,
      content: description,
    },
    {
      property: `og:image`,
      content: image,
    },
    {
      property: `description`,
      content: description,
    },
    {
      property: `keywords`,
      content: keywords,
    },
    {
      name: `twitter:card`,
      content: `summary`,
    },
    {
      name: `twitter:site`,
      content: `@RippleXDev`,
    },
    {
      name: `twitter:title`,
      content: docTitle,
    },
    {
      name: `twitter:description`,
      content: description,
    },
    {
      name: `twitter:image`,
      content: image,
    },
  ]

  return (
    <div className={`page-${slug}`}>
      <Header />
      <Helmet title={docTitle} meta={metadata}>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Work+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400;1,700;1,900&display=swap"
          rel="stylesheet"
          crossOrigin="anonymous"
        />
      </Helmet>
      <ProgressBar />
      <div className="page-body">
        <h1 className="text-center">{header}</h1>
        <div className="page-content">{children}</div>
        <CallToAction />
      </div>
      <Footer />
    </div>
  )
}
